// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"5360f446","117":"011eb1e3","411":"011eb1e3","590":"011eb1e3","713":"d8019c34","926":"66702c5a"}[chunkId] + ".chunk.css";
};